import { Component, Inject, OnInit } from '@angular/core';
import { DwCacheService, DwComponent, DwComponentType, DwLookupInfo, DwMessage, DwMessageSeverity, DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, getErrorDetails } from '@devwareapps/devware-cap';
import { ApplicantRepositoryService } from '../../../applicant/services/applicant-repository.service';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { ScheduleHoldUtilService } from '../../services/schedule-hold-util.service';
import { ScheduleSelectorService } from '../../services/schedule-selector.service';
import { ExaminerSlotSelection } from '../../models/examiner-slot-selection.model';
import { AirportWithAddressInfoQueryEntity, AppMetaDataItemNames, AppMetaDataLookups, CheckRideRequestEntity, CheckRideRequestPaymentPartyAllItems, CheckRideRequestPaymentPartyEntity, FlightSchoolApplicantEntity, SchoolFeatureAllItems } from '../../../../meta-data/app-meta-data.service';
import { ExaminerBookingSearchResultsConfigComponent } from '../examiner-booking-search-results-config/examiner-booking-search-results-config.component';
import { ExaminerBookingVariableContext } from '../../models/examiner-booking-variable-context.model';
import { ScheduleMultipleBookingUtilService } from '../../services/schedule-multiple-booking-util.service';
import { CheckRideCreationRefData } from '../../models/checkride-creation-ref-data.model';
import { combineLatest, Observable, of } from 'rxjs';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';
import { CheckRideRequestEntityExt } from '../../../../meta-data/extensions/check-ride-request-entity.model';
import { catchError, debounceTime, mergeMap, tap } from 'rxjs/operators';
import { CheckrideRefItem } from '../../models/checkride-ref-item.model';
import { PaymentRepositoryService } from '../../../payments/services/payment-repository.service';
import { PaymentChargeRequest } from '../../../payments/models/payment-charge-request.model';
// import { CheckrideVariables } from '../../../applicant/models/checkride-variables.model';
import { SchoolFeatures } from '../../../schools/models/school-features.model';

@DwComponent({
  key: 'exminer-booking-multiple-creation',
  name: ' Examiner Booking - Create Multiple',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  configComponent: ExaminerBookingSearchResultsConfigComponent,
  isGlobal: false
})
@Component({
  selector: 'app-examiner-booking-multiple-creation',
  templateUrl: './examiner-booking-multiple-creation.component.html',
  styleUrls: ['./examiner-booking-multiple-creation.component.scss']
})
export class ExaminerBookingMultipleCreationComponent implements OnInit {
  formApi: DwMetaDataFormApi;
  selections: ExaminerSlotSelection[] = [];
  variableContext: ExaminerBookingVariableContext;
  lastVariableContext: ExaminerBookingVariableContext;
  paymentParties: CheckRideRequestPaymentPartyEntity[];
  checkRides: CheckrideRefItem[] = [];
  allApplicants: any;

  scheduleHoldsComplete: boolean = false;

  useTestData = false;
  statusItems: DwLookupInfo[] = [];
  validCheckrideCount: number;

  message: DwMessage;
  features: SchoolFeatures;

  constructor(

    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    private examinerRepositoryService: ExaminerRepositoryService,
    private applicantRepositoryService: ApplicantRepositoryService,
    private scheduleHoldUtilService: ScheduleHoldUtilService,
    private scheduleSelectorService: ScheduleSelectorService,
    private scheduleMultipleBookingUtilService: ScheduleMultipleBookingUtilService,
    private schoolRepositoryService: SchoolRepositoryService,
    private paymentRepositoryService: PaymentRepositoryService,
    private dwCacheSerivce: DwCacheService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService
  ) {
    this.formApi = dwMetaDataFormStateService.state.formApi;
  }

  ngOnInit(): void {
    this.loadReferenceData();
  }

  loadReferenceData() {
    const obs: Observable<any>[] = [];

    obs.push(this.examinerRepositoryService.getCheckRideRequestPaymentParty());
    obs.push(this.schoolRepositoryService.getCurrentFlightSchoolApplicants());
    obs.push(this.dwMetaDataService.getLookup(AppMetaDataLookups.CheckRideRequestSubStatusAllItems))

    obs.push(this.schoolRepositoryService.getSchoolFeatures());

    combineLatest(obs).subscribe(([paymentParties, applicants, statusItems, features]) => {
      this.paymentParties = paymentParties;
      this.allApplicants = applicants;
      this.statusItems = statusItems;
      this.features = features;

      this.setupData();
    });
  }

  setupData() {
    this.setupCheckrides();

    this.formApi.getVariableContext().subscribe((context) => {
      this.variableContext = context;
      this.checkForVariableChanges();
    });

    // this.formApi.getFormDataChanges<CheckRideRequestEntity>()
    //   .pipe(debounceTime(50))
    //   .subscribe(() => {
    //     this.setupBookingCost();
    //   });
  }

  // setupBookingCost() {
  //   const checkride = this.formApi.getFormData<CheckRideRequestEntity>();

  //   if (!this.features) {
  //     return;
  //   }

  //   // if (this.hasFeature(SchoolFeatureAllItems.SchoolBookingFeeFreeTrial)) {
  //   //   this.formApi.patchFormData({ PilexosBookingCost: 0, PilexosBookingCostPaymentPartyId: CheckRideRequestPaymentPartyAllItems.FlightSchool, PilexosPayment: true });

  //   //   return;
  //   // } 

  //   const bookingCost = this.examinerRepositoryService.getPilexosBookingCost(checkride.CheckRideTestTypeId, checkride.PilexosBookingCostPaymentPartyId, this.paymentParties);

  //   if (bookingCost != checkride.PilexosBookingCost) {
  //     // Update the booking cost on all checkrides
  //     for (const checkrideRef of this.checkRides) {
  //       checkrideRef.checkride.PilexosBookingCost = bookingCost;
  //     }

  //     this.formApi.patchFormData({ PilexosBookingCost: bookingCost });
  //   }
  // }

  private hasFeature(feature: any): boolean {
    return this.features?.SchoolFeatures?.find(f => f == feature) != null;
  }

  returnToSearch() {
    // TODO: Needs logic to return to search

    this.formApi.setVariableValue("SHOW_SEARCH", true);
  }

  checkForVariableChanges() {
    if (this.variableContext.Show_Search == false && this.lastVariableContext?.Show_Search == true) {
      this.setupCheckrides();
    }
    if (this.variableContext.Show_Search == true && this.lastVariableContext?.Show_Search == false) {
      this.cancelCheckrideHolds();
    }

    this.lastVariableContext = this.variableContext;
  }



  setupCheckrides() {
    // Only run logic if visible
    this.selections = this.scheduleSelectorService.getSelections();

    if (this.selections.length > 0) {
      this.storeSelections();
    } else {
      this.selections = this.getStoredSelections();
    }

    if (this.selections.length == 0) {
      return;
    }

    if (this.selections.length == 1) {
      console.log('Single selection - should use single booking component');
      return;
    }


    const referenceCheckRide = this.formApi.getFormData<CheckRideRequestEntity>();

    console.log(`Creating checkrides for ${this.selections.length} selections`, referenceCheckRide, this.features);
    if (!this.features) {
      console.log('Features not loaded yet');
      return;
    }

    this.getAirportInfoList(this.selections)
      .subscribe(airportInfoList => {
        const refData: CheckRideCreationRefData = {
          variables: this.variableContext,
          applicants: this.getCurrentApplicants(referenceCheckRide),
          checkRideRequestPaymentPartyList: this.paymentParties,
          referenceCheckRide: referenceCheckRide,
          airportInfoList: airportInfoList,
          features: this.features
        };

        this.checkRides = this.scheduleMultipleBookingUtilService.createCheckrideBookings(this.selections, refData);

        if (this.checkRides.length == 0) {
          return;
        }

        this.scheduleMultipleBookingUtilService.validateCheckrideBookings(this.checkRides).subscribe(validatedCheckrides => {

          this.checkRides = validatedCheckrides;

          this.updateCheckrideStatusDisplay();

          const validCheckrides = this.checkRides.filter(cr => cr.validationResult?.IsValid).map(checkride => checkride.checkride);

          this.validCheckrideCount = validCheckrides.length;
          this.message = null;

          if (validCheckrides.length == 0) {
            this.scheduleHoldsComplete = false;

            this.message = {
              severity: DwMessageSeverity.warning,
              messageHeading: 'No Valid Bookings',
              messageBody: 'There are no valid bookings to create. Please review the warnings for each booking.'
            };

            return;
          }

          // Track schedule hold
          this.scheduleHoldUtilService.startScheduleHoldMultiple(validCheckrides).subscribe(results => {
            for (let i = 0; i < results.length; i++) {
              this.checkRides[i].scheduleHold = results[i];
            }

            this.scheduleHoldsComplete = true;
          });
        });
      });
  }

  cancelCheckrideHolds() {
    if (!this.scheduleHoldsComplete) {
      return;
    }

    const obs: Observable<any>[] = [];
    for (const checkrideRef of this.checkRides) {
      if (checkrideRef.scheduleHold?.CheckRideScheduleHold) {
        obs.push(this.scheduleHoldUtilService.cancelScheduleHold(checkrideRef.scheduleHold.CheckRideScheduleHold, checkrideRef.checkride));
      }

      checkrideRef.scheduleHold = null;
    }

    this.scheduleHoldsComplete = false;

    if (obs.length > 0) {
      combineLatest(obs).subscribe(() => {
        // nothing to do
      });
    }
  }

  private updateCheckrideStatusDisplay() {
    for (const checkrideRef of this.checkRides) {
      const statusId = checkrideRef.savingInfo?.savedCheckride?.CheckRideRequestSubStatusId || checkrideRef.checkride.CheckRideRequestSubStatusId;

      checkrideRef.checkRideStatusDisplay = this.getStatusDisplay(statusId);
    }
  }

  private getStatusDisplay(statusId: number): string {
    const status = this.statusItems.find(s => s.Id == statusId.toString());
    return status ? status.Display : '';
  }

  private airportInfoCache: any = {};

  /**
   * Cache airport info to reduce calls
   * @param selections 
   * @returns 
   */
  private getAirportInfoList(selections: ExaminerSlotSelection[]): Observable<AirportWithAddressInfoQueryEntity[]> {

    const airportIds = selections.map(selection => selection.searchResult.LocationDistancesAirportId);

    let hasAll = true;

    const airportInfo: AirportWithAddressInfoQueryEntity[] = [];
    for (const airportId of airportIds) {
      if (!this.airportInfoCache[airportId]) {
        hasAll = false;
        break;
      }

      airportInfo.push(this.airportInfoCache[airportId]);
    }

    if (hasAll) {
      return of(airportInfo);
    }

    return this.examinerRepositoryService.getAirportInfoList(airportIds)
      .pipe(tap(airportInfoList => {
        for (const airportInfo of airportInfoList) {
          this.airportInfoCache[airportInfo.AirportId] = airportInfo;
        }
      }));
  }

  getCurrentApplicants(checkrideReferenceCheckRide: CheckRideRequestEntity): FlightSchoolApplicantEntity[] {
    const applicants: FlightSchoolApplicantEntity[] = [];

    let applicantIds: number[] = [checkrideReferenceCheckRide.FlightSchoolApplicantId];
    if (this.variableContext?.BookMultiple) {
      if (!this.variableContext?.Applicants) {
        return [];
      }

      applicantIds = this.variableContext.Applicants.split(',').map(id => parseInt(id, 10));
    }

    for (const id of applicantIds) {
      const applicant = this.allApplicants.find(a => a.FlightSchoolApplicantId === id);
      if (applicant) {
        applicants.push(applicant);
      }
    }

    return applicants;
  }

  creatingBookings = false;
  creatingBookingComplete = false;


  createBookings() {
    if (this.validateForm() == false) {
      this.creatingBookings = false;
      return;
    }

    this.creatingBookings = true;

    const validCheckrides = this.checkRides.filter(cr => cr.validationResult?.IsValid);

    for (const checkride of validCheckrides) {
      checkride.savingInfo = {
        isSaving: false,
      }
    }

    const checkrideRef = validCheckrides[0].checkride;

    const variables = this.formApi.getVariableContextValue<ExaminerBookingVariableContext>();

    // Build the charge request
    this.chargeRequest = {
      addCardToCustomer: false,
      captureCharge: false,
      cardOwnerPaymentPartyId: CheckRideRequestPaymentPartyAllItems.FlightSchool,
      paymentPartyId: checkrideRef.PilexosBookingCostPaymentPartyId,
      amount: checkrideRef.PilexosBookingCost,
      markDefaultCard: false,
      emailCCReceipt: '',
      paymentDiscountCode: variables.Discount_Code,
      customerReferenceKey: '', // Determine on server side and will validate that card belongs to customer
      cardDetails: {
        cardReferenceKey: variables.PaymentMethodCardReference,
      }
    }

    this.createBookingsSequentially(validCheckrides, true).subscribe(result => {
      this.creatingBookings = false;
      this.creatingBookingComplete = true;




      this.message = {
        severity: DwMessageSeverity.success,
        messageHeading: 'Bookings Created',
        messageBody: `All bookings have been created and both the students and examiners have been notified by email.`
      };

      this.updateCheckrideStatusDisplay();

      // Recreate to force UI update
      this.checkRides = [...this.checkRides]

      if (result) {
        this.formApi.setVariableValue("BookMultipleComplete", true);
      } else {
        // Handle error case
      }

    });
  }

  close() {
    this.formApi.formGroup.reset();
    this.formApi.cancel();
  }

  validateForm(): boolean {

    return true;

    // Don't validate form since we're not using any fields on it
    const validationResult = this.formApi.validateForm();

    if (validationResult.isValid) {
      return true;
    }

    const message = this.formApi.createValidationMessage(validationResult);

    this.formApi.setFormMessage(message);

    return false;
  }

  chargeRequest: PaymentChargeRequest;


  private createBookingsSequentially(checkrides: CheckrideRefItem[], continueOnError: boolean = false): Observable<boolean> {
    const result: any = {};

    if (checkrides.length == 0) {
      return of(true);
    }

    const current = checkrides[0];
    var remaining = checkrides.slice(1);

    current.savingInfo.isSaving = true;
    var resultOb = this.paymentRepositoryService.createSchoolCheckridePayment(current.checkride, this.chargeRequest);

    return resultOb.pipe(mergeMap(savedCheckrideResult => {
      const savedCheckride = savedCheckrideResult.CheckRideRequestJSON ? JSON.parse(savedCheckrideResult.CheckRideRequestJSON) as CheckRideRequestEntityExt : null;

      if (savedCheckride) {
        current.savingInfo.savedCheckride = savedCheckride;
        current.checkride = savedCheckride;
      }

      current.savingInfo.isSaving = false;
      current.savingInfo.isSaveComplete = true;

      if (savedCheckrideResult.PaymentResult?.IsSuccess == false) {
        current.savingInfo.isSaving = false;
        current.savingInfo.errorMessage = savedCheckrideResult.PaymentResult.ErrorMessage;
        current.savingInfo.isSaveError = true;
      }

      if (remaining.length == 0) {
        return of(true);
      }

      return this.createBookingsSequentially(remaining, continueOnError);
    }), catchError(error => {
      const errorDetails = getErrorDetails(error);
      current.savingInfo.isSaving = false;
      current.savingInfo.errorMessage = errorDetails.message;
      current.savingInfo.isSaveError = true;

      if (continueOnError) {
        return this.createBookingsSequentially(remaining, continueOnError);
      } else {
        return of(false);
      }
    }));
  }


  storeSelections() {
    if (!this.useTestData) {
      return;
    }

    localStorage.setItem('examinerSlotSelections', JSON.stringify(this.selections));
  }

  getStoredSelections(): ExaminerSlotSelection[] {
    if (!this.useTestData) {
      return [];
    }

    const storedSelections = localStorage.getItem('examinerSlotSelections');
    if (storedSelections) {
      return JSON.parse(storedSelections);
    }
    return [];
  }

}

